import Vue from 'vue'
import store from '@/store'

const URL = store.state.apiUrl + '/api/v1'

export const getDaily = (date) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  return Vue.http.get(URL + `/admin/transaction/filter/day?date=${date}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getDailyThirdParty = (date) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  return Vue.http.get(URL + `/admin/transaction/filter/third-party?date=${date}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getMonthly = (date) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  return Vue.http.get(URL + `/admin/transaction/filter/month?date=${date}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getPrimaryIncome = (date) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  return Vue.http.get(URL + `/admin/report/primary?date=${date}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getDailyProductSales = (date) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  let outlets = store.state.auth.isAllOutlet ? -1 : store.getters.activeOutletID
  return Vue.http.get(URL + `/admin/transaction/report/daily?date=${date}&outlets=${outlets}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getMonthlyProductSales = (date) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  let outlets = store.state.auth.isAllOutlet ? -1 : store.getters.activeOutletID
  return Vue.http.get(URL + `/admin/transaction/report/monthly?date=${date}&outlets=${outlets}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getYearly = (date) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  return Vue.http.get(URL + `/admin/transaction/filter/yearly?date=${date}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getDateRange = (dateStart, dateEnd) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  return Vue.http.get(URL + `/admin/transaction/filter/custom?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getDateRangeCategorySales = (dateStart, dateEnd) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  return Vue.http.get(URL + `/admin/report/product-type?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
    headers
  })
    .then((response) => {
      return response.body
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getDateRangeProductSales = (dateStart, dateEnd) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  let outlets = store.state.auth.isAllOutlet ? -1 : store.getters.activeOutletID
  return Vue.http.get(URL + `/admin/transaction/report/custom?dateStart=${dateStart}&dateEnd=${dateEnd}&outlets=${outlets}`, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log(err)
    })
}

export const printDailyBill = (data = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  const params = {
    'id': data.id,
    'date': data.date,
    'products': data.products,
    'note': data.note || ''
    // 'addons': addons
    // 'addons_price': bill.items.addons_price
  }
  return Vue.http.post('http://localhost:8000/api/v1/printBill', params, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log('error print')
      console.log(err)
    })
}

export const syncToHarmony = (data = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.getters.auth.user.api_token}`
  }
  const params = {
    'date': data.date
  }
  return Vue.http.post(URL + `/admin/transaction/sync/harmony`, params, {
    headers
  })
    .then((response) => {
      return response.body.data
    })
    .catch((err) => {
      console.log('error sync to harmony')
      console.log(err)
    })
}



// WEBPACK FOOTER //
// ./src/services/dashboard.js